// extracted by mini-css-extract-plugin
module.exports = {"layoutBox":"Licenses_layoutBox__1--Le","center":"Licenses_center__2f6S-","title":"Licenses_title__1cmCi","flexList":"Licenses_flexList__24hrM"};